var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 bg-primary text-center  text-white p-2"},[_c('h5',[_vm._v(_vm._s(_vm.titulo))]),_c('p',{},[_vm._v(_vm._s(_vm.subtitulo))])])}
var staticRenderFns = []

export { render, staticRenderFns }